import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import OpenNotificationWithIcon from "../VibrantSolComponents/Notification"; // Adjust path
import { googleLoginAPI } from "../../features/Login/LoginApi";

const GoogleLoginButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential;

    if (!idToken) {
      OpenNotificationWithIcon("error", "No ID token received");
      return;
    }

    const creds = { credential: idToken };
    const success = await dispatch(googleLoginAPI(creds));

    if (success) {
      OpenNotificationWithIcon("success", "Google login successful");
      navigate("/dashboard");
    } else {
      OpenNotificationWithIcon("error", "Google login failed");
    }
  };

  const handleGoogleError = () => {
    OpenNotificationWithIcon("error", "Google login failed");
  };

  return (
    <GoogleLogin
      text="Google"
      onSuccess={handleGoogleSuccess}
      onError={handleGoogleError}
      useOneTap={false}
      auto_select={false}
    />
  );
};

export default GoogleLoginButton;
